import Immutable from 'immutable';
import { createSelector } from 'reselect';
import { selectCurrentCoursePath } from '../Courses/selectors';
import { FetchStatus } from './constants';

const kudosSelector = (state) => state.Kudos || Immutable.Map();

export const kudosByCurrentCourseSelector = createSelector(
  kudosSelector,
  selectCurrentCoursePath,
  (kudos, coursePath) => kudos.getIn([coursePath, 'kudos'], Immutable.Map())
);

export const selectKudosByCurrentCourseFetchStatus = createSelector(
  kudosSelector,
  selectCurrentCoursePath,
  (kudos, coursePath) => kudos.getIn([coursePath, 'status'], FetchStatus.START)
);
